var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "batch-recharge-form" }, [
    _c(
      "div",
      { staticClass: "form-section" },
      [
        _c("div", { staticClass: "section-label" }, [
          _vm._v(
            " " +
              _vm._s(_vm.$t("basicData.ImportPaymentAndReceivingInformation")) +
              " "
          ),
        ]),
        _c("DragUploadCmp", {
          ref: "paymentUploadRef",
          attrs: {
            "auto-upload": false,
            "file-size": 5,
            "file-type": _vm.paymentFileType,
            limit: 1,
            multiple: false,
            tips: _vm.$t("basicData.OnlySupportsXlsXlsxFiles"),
          },
          on: { change: _vm.handlePaymentFileChange },
        }),
        !_vm.paymentFileList.length
          ? _c(
              "div",
              {
                staticClass: "download-link",
                on: { click: _vm.downloadTemplate },
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("basicData.DownloadTheTemplate")) + " "
                ),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "form-section" },
      [
        _c("div", { staticClass: "section-label" }, [
          _vm._v(" " + _vm._s(_vm.$t("basicData.ImportReceiptFile")) + " "),
        ]),
        _c("DragUploadCmp", {
          ref: "receiptUploadRef",
          attrs: {
            "file-size": 10,
            "file-type": _vm.receiptFileType,
            limit: 20,
            multiple: false,
            tips: _vm.$t("basicData.FileOnlySupportsZipJpgJpegPngPdf"),
          },
          on: { change: _vm.handleReceiptFileChange },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "form-footer" },
      [
        _c(
          "el-button",
          { attrs: { size: "small" }, on: { click: _vm.cancel } },
          [_vm._v(" " + _vm._s(_vm.$t("basicData.Cancel")) + " ")]
        ),
        _c(
          "el-button",
          {
            attrs: {
              loading: _vm.loading || _vm.parseLoading,
              size: "small",
              type: "primary",
            },
            on: { click: _vm.confirm },
          },
          [_vm._v(_vm._s(_vm.$t("basicData.determine")) + " ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }